import * as types from "./homecareBulkCancelTypes";
import { payloadActionCreator, emptyActionCreator } from "../../utils/actions";

export const getHomeCareBulkCancelOrdersRequest = payloadActionCreator(
  types.GET_HOMECARE_BULK_CANCEL_ORDERS_REQUEST
);
export const getHomeCareBulkCancelOrdersSuccess = payloadActionCreator(
  types.GET_HOMECARE_BULK_CANCEL_ORDERS_SUCCESS
);
export const getHomeCareBulkCancelOrdersFailure = payloadActionCreator(
  types.GET_HOMECARE_BULK_CANCEL_ORDERS_FAILURE
);

export const cancelHomeCareBulkOrdersRequest = payloadActionCreator(
  types.CANCEL_HOMECARE_BULK_ORDERS_REQUEST
);
export const cancelHomeCareBulkOrdersSuccess = payloadActionCreator(
  types.CANCEL_HOMECARE_BULK_ORDERS_SUCCESS
);
export const cancelHomeCareBulkOrdersFailure = payloadActionCreator(
  types.CANCEL_HOMECARE_BULK_ORDERS_FAILURE
);

export const resetHomeCareBulkCancelOrders = emptyActionCreator(
  types.RESET_HOMECARE_BULK_CANCEL_ORDERS
);
